import { createSelector } from 'reselect'

export const getCurrentAd = createSelector(
  (state) => state && state.ads && state.ads.detail && state.ads.detail.currentAd ? state.ads.detail.currentAd : null,
  (ad) => ad
)
